import React, { useState, useEffect } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import AutocompleteInput from "../../../Components/AutocompleteInput";
import { formatTime } from "../../../tools";
import { useTranslation } from "react-i18next";

// One time slot every 30 minutes.
const timeSlots = Array.from(new Array(24 * 2)).map(
  (_, index) =>
    `${index < 20 ? "0" : ""}${Math.floor(index / 2)}:${
      index % 2 === 0 ? "00" : "30"
    }`
);

function TimeMenu({ event, handleTimeChange, handleLogicChange, index = "" }) {
  const { t } = useTranslation();
  const logics = [
    { value: "at", title: t("scheduler.at") },
    { value: "between", title: t("scheduler.between") },
  ];
  const initLogic = event["end" + index] === null ? "at" : "between";
  const initStartTime = formatTime(event["start" + index]);
  const initEndTime = formatTime(event["end" + index]);
  const [logic, setLogic] = useState(initLogic);
  const [startTime, setStartTime] = useState(initStartTime);
  const [endTime, setEndTime] = useState(initEndTime);
  const [isLogicChanged, setIsLogicChanged] = useState(false); // update the endTime

  useEffect(() => {
    if (logic === "between" && isLogicChanged) {
      setIsLogicChanged(false);
      setEndTime(formatTime(event["end" + index]));
    }
  }, [isLogicChanged, logic, event, index]);

  return (
    <div style={{ display: "flex" }}>
      <div>
        <FormControl>
          <Select
            variant="standard"
            value={logic}
            onChange={(event) => {
              handleLogicChange(index)(event);
              setLogic(event.target.value);
              setIsLogicChanged(true);
            }}
            displayEmpty
            inputProps={{ "aria-label": "time interval" }}
          >
            {logics.map((item) => (
              <MenuItem key={"MenuItem" + item.value} value={item.value}>
                {item.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div>
        <div style={{ display: "flex" }}>
          <AutocompleteInput
            width={80}
            options={timeSlots}
            value={startTime}
            onChange={(event, value) => {
              setStartTime(value);
              handleTimeChange("start" + index)(event, value);
            }}
            variant="scheduler"
            textAlign="center"
          />
          {event["end" + index] ? (
            <div style={{ display: "flex" }}>
              <AutocompleteInput
                width={80}
                options={timeSlots}
                value={endTime}
                onChange={(event, value) => {
                  setEndTime(value);
                  handleTimeChange("end" + index)(event, value);
                }}
                variant="scheduler"
                textAlign="center"
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

export default TimeMenu;
